import { getBankacctList } from "src/apis/bankacctApi";
import { getCommonCodeList, getConditionCodeList, getMajorCodeOptions, getMinorCodeList } from "src/apis/commonCodeApi";
import { getCustomerList } from "src/apis/customerApi";
import { getEmployeeList } from "src/apis/employeeApi";
import { getMenuModalList } from "src/apis/menuApi";
// import { getBookmarkList } from "src/apis/userApi";
import { getAllWarehouses } from "src/apis/warehouseApi";
import { getAllWorkPlaces } from "src/apis/workPlaceApi";
import { CodeResponseDto } from "src/dtos/code/codeDto";
import { CompanyDto } from "src/dtos/company/companyDto";
import { CustomerResponseDto } from "src/dtos/customer/customerResponseDto";
import { EmployeeDto } from "src/dtos/employee/employeeDto";
import { MenuDto } from "src/dtos/menu/menuDto";
import { OrganizationDto } from "src/dtos/organization/organizationDto";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { WorkPlaceDto } from "src/dtos/workplace/workPlaceDto";
import { BankAcctDto } from "src/dtos/bank/bankacctDto";
import { getCompCdList, getOrgCdList } from "src/utils/code/codeUtil";
import { create } from "zustand";

export interface BookmarkCdList {
	key: string;
	name: string;
	type: string;
}

export interface CommonCodeStore {

	
	// 공통코드 관련
	majorCodeList: CodeResponseDto[];
	setMajorCodeList: (list: CodeResponseDto[], withFilteredList?: boolean) => void;

	fetchBankacctCdCode: () => Promise<void>;
	fetchCommonCode: () => Promise<void>;
	fetchCustomCdCode: () => Promise<void>;
	fetchCompCdCode: () => Promise<void>;
	fetchEmployeeCdCode: () => Promise<void>;
	fetchMenuCdCode: () => Promise<void>;
	fetchBookmarkCdCode: () => Promise<void>;
	fetchOrgCdCode: () => Promise<void>;
	fetchWarehouseCdCode: () => Promise<void>;
	fetchWorkPlaceCdCode: () => Promise<void>;


	// 초기화
	initData: () => void;

	// 지역코드
	areaCdList: CodeResponseDto[];				setAreaCdList: (data: CodeResponseDto[]) => void;
	// 시스템권한
	autGroupList: CodeResponseDto[];			setAutGroupList: (data: CodeResponseDto[]) => void;
	// 생년월일 타입 코드
	birthdayTypeList: CodeResponseDto[];		setBirthdayTypeList: (data: CodeResponseDto[]) => void;
	// 은행코드
	bankCdList: CodeResponseDto[];				setBankCdList: (data: CodeResponseDto[]) => void;
	// 계좌유형
	bankAcctTypeList: CodeResponseDto[];		setBankAcctTypeList: (data: CodeResponseDto[]) => void;
	// 브랜드코드
	brandCdList: CodeResponseDto[];				setBrandCdList: (data: CodeResponseDto[]) => void;
	// 국가 코드
	countryCdList: CodeResponseDto[];				setCountryCdList: (data: CodeResponseDto[]) => void;
	// 보유차량 타입 코드
	carTypeList: CodeResponseDto[];				setCarTypeList: (data: CodeResponseDto[]) => void;
	// 차량모델 코드
	carModelList: CodeResponseDto[];			setCarModelList: (data: CodeResponseDto[]) => void;
	// 입사유형
	compJoinTpList: CodeResponseDto[];			setCompJoinTpList: (data: CodeResponseDto[]) => void;
	// 데이터수집주기
	cycleList: CodeResponseDto[];				setCycleList: (data: CodeResponseDto[]) => void;
	// 개발상태
	devStsList: CodeResponseDto[];				setDevStsList: (data: CodeResponseDto[]) => void;
	// 개발자
	devloperList: CodeResponseDto[];			setDevloperList: (data: CodeResponseDto[]) => void;
	// 비가동사유
	downtimeValueList: CodeResponseDto[];		setDowntimeValueList: (data: CodeResponseDto[]) => void;
	// 최종학력 구분
	educationTypeList: CodeResponseDto[];		setEducationTypeList: (data: CodeResponseDto[]) => void;
	// 재직상태
	empstsCdList: CodeResponseDto[];			setEmpstsCdList: (data: CodeResponseDto[]) => void;
	// 설비유형
	eqmTypeList: CodeResponseDto[];				setEqmTypeList: (data: CodeResponseDto[]) => void;
	// 설비상태
	eqmStatusList: CodeResponseDto[];			setEqmStatusList: (data: CodeResponseDto[]) => void;
	// 검사결과
	faultyValueList: CodeResponseDto[];			setFaultyValueList: (data: CodeResponseDto[]) => void;
	// 화페코드
	moneyCdList: CodeResponseDto[];				setMoneyCdList: (data: CodeResponseDto[]) => void;
	// 내외부구분
	inoutBoundList: CodeResponseDto[];			setInoutBoundList: (data: CodeResponseDto[]) => void;
	// 수불구분 - 배송방법
	inoutClassList: CodeResponseDto[];			setInoutClassList: (data: CodeResponseDto[]) => void;
	// 수불방법 - 출고구분
	inoutMethodList: CodeResponseDto[];			setInoutMethodList: (data: CodeResponseDto[]) => void;
	// 이자유형
	interesttypeList: CodeResponseDto[];		setInteresttypeList: (data: CodeResponseDto[]) => void;
	// 점검유형
	inspectTypeList: CodeResponseDto[];			setInspectTypeList: (data: CodeResponseDto[]) => void;
	// 아이템계정
	itemAccountList: CodeResponseDto[];			setItemAccountList: (data: CodeResponseDto[]) => void;
	// 아이템그룹
	itemGroupList: CodeResponseDto[];			setItemGroupList: (data: CodeResponseDto[]) => void;
	// 출고물류상태
	itemStatusList: CodeResponseDto[];			setItemStatusList: (data: CodeResponseDto[]) => void;
	// 직책
	jcCdList: CodeResponseDto[];				setJcCdList: (data: CodeResponseDto[]) => void;
	//작업조
	jobTeamList: CodeResponseDto[];				setJobTeamList: (data: CodeResponseDto[]) => void;
	// 직종(직군)
	jjCdList: CodeResponseDto[];				setJjCdList: (data: CodeResponseDto[]) => void;
	// 직위
	jwCdList: CodeResponseDto[];				setJwCdList: (data: CodeResponseDto[]) => void;
	// KPI 구분
	kpiKeyList: CodeResponseDto[];				setKpiKeyList: (data: CodeResponseDto[]) => void;
	// 작업지시구분
	ordTypeList: CodeResponseDto[];				setOrdTypeList: (data: CodeResponseDto[]) => void;
	// 수금/지불 방법
	paycollectList: CodeResponseDto[];			setPaycollectList: (data: CodeResponseDto[]) => void;
	// 수금/지불 기준
	paycollectTargetList: CodeResponseDto[];	setPaycollectTargetList: (data: CodeResponseDto[]) => void;
	// 급여구분
	payTpList: CodeResponseDto[];					setPayTpList: (data: CodeResponseDto[]) => void;
	// 퇴직사유 - 퇴사구분 리스트
	retireTypeList: CodeResponseDto[];			setRetireTypeList: (data: CodeResponseDto[]) => void;
	// 시스템
	systemList: CodeResponseDto[];				setSystemList: (data: CodeResponseDto[]) => void;
	// 시험분류
	testClassList: CodeResponseDto[];			setTestClassList: (data: CodeResponseDto[]) => void;
	// 단위
	unitList: CodeResponseDto[];					setUnitList: (data: CodeResponseDto[]) => void;
	// 결과유형
	valueTypeList: CodeResponseDto[];			setValueTypeList: (data: CodeResponseDto[]) => void;
	// 부가세 유형
	vatTypeList: CodeResponseDto[];				setVatTypeList: (data: CodeResponseDto[]) => void;
	// 세금계산서 납입여부
	vatIoFlagList: CodeResponseDto[];			setVatIoFlagList: (data: CodeResponseDto[]) => void;
	// 작업공정유형
	workProcessList: CodeResponseDto[];			setWorkProcessList: (data: CodeResponseDto[]) => void;
	// 물류
	wmsCdList: CodeResponseDto[];				setWmsCdList: (data: CodeResponseDto[]) => void;
	// 입고구분
	wmsInTypeCdList: CodeResponseDto[];			setWmsInTypeCdList: (data: CodeResponseDto[]) => void;
	// 출고구분
	wmsOutTypeCdList: CodeResponseDto[]; 		setWmsOutTypeCdList: (data: CodeResponseDto[]) => void;
	// 입고분류
	inoutTypeList: CodeResponseDto[];			setInoutTypeList: (data: CodeResponseDto[]) => void;
	// yes/no
	yesNoList: CodeResponseDto[];				setYesNoList: (data: CodeResponseDto[]) => void;
	// yes/no 숫자
	yesNoNumList: CodeResponseDto[];			setYesNoNumList: (data: CodeResponseDto[]) => void;

	// 계좌 코드
	bankacctCdList: BankAcctDto[];				setBankacctCdList: (data: BankAcctDto[]) => void;
	// 즐겨찾기 코드
	bookmarkCdList: BookmarkCdList[];			setBookmarkCdList: (data: BookmarkCdList[]) => void;
	// 거래처 코드
	customCdList: CustomerResponseDto[];		setCustomCdList: (data: CustomerResponseDto[]) => void;
	// 사업장 코드
	compCdList: CompanyDto[];					setCompCdList: (data: CompanyDto[]) => void;
	// 사원 코드
	employeeCdList: EmployeeDto[];				setEmployeeCdList: (data: EmployeeDto[]) => void;
	// 메뉴 코드
	menuCdList: MenuDto[];						setMenuCdList: (data: MenuDto[]) => void;
	// 조직 코드
	orgCdList: OrganizationDto[];				setOrgCdList: (data: OrganizationDto[]) => void;
	// 창고 코드
	warehouseCdList: WareHouseDto[];			setWarehouseCdList: (data: WareHouseDto[]) => void;
	// 공정 정보 코드
	workPlaceList: WorkPlaceDto[];				setWorkPlaceList: (data: WorkPlaceDto[]) => void;

	plcaddressList: CodeResponseDto[];			setPlcaddressList: (data: CodeResponseDto[]) => void;

	bookMarkCd: string;
	
	// 검색 조건 관련 상태 추가
	searchCondition: {
		majorCd: string;
		minorCd: string;
		codeNm: string;
	};
	setSearchCondition: (condition: { majorCd?: string; minorCd?: string; codeNm?: string }) => void;
	resetSearchCondition: () => void;

	// 선택된 메이저코드에 따른 상세코드 리스트
	minorCodeOptions: CodeResponseDto[];
	setMinorCodeOptions: (options: CodeResponseDto[]) => void;
	fetchMinorCodeOptions: (majorCd: string) => Promise<void>;

	// 검색조건용 상세코드 관련
	conditionCodeOptions: CodeResponseDto[];
	setConditionCodeOptions: (options: CodeResponseDto[]) => void;
	fetchConditionCodeOptions: (majorCd: string) => Promise<void>;

	// 메이저코드 드롭다운 옵션 관련
	majorCodeOptions: CodeResponseDto[];
	setMajorCodeOptions: (options: CodeResponseDto[]) => void;
	fetchMajorCodeOptions: () => Promise<void>;
}

export const allCd: CodeResponseDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	majorCd: "",
	minorCd: "",
	codeNm: "",
	sysFlg: "",
	dispSeq: 0,
	ref01: "",
	ref02: "",
	ref03: "",
	ref04: "",
	ref05: "",
	ref06: "",
	ref07: "",
	ref08: "",
	ref09: "",
	ref10: "",
	remark: ""
}


export const useCommonCodeStore = create<CommonCodeStore>((set) => ({

	
	majorCodeList: [],
	setMajorCodeList: (list: CodeResponseDto[], withFilteredList?: boolean) => set((state) => ({
		...state,
		majorCodeList: list,

	})),

	fetchCommonCode: async () => {

		const [
			majorCodeListRes,
			areaCdListRes,
			autGroupListRes,
			birthdayTypeListRes,
			bankCdListRes,
			bankAcctTypeListRes,
			brandCdListRes,
			countryCdListRes,
			carTypeListRes,
			carModelListRes,
			compJoinTpListRes,
			cycleListRes,
			devStsListRes,
			devloperListRes,
			downtimeValueListRes,
			educationTypeListRes,
			empstsCdListRes,
			eqmTypeListRes,
			eqmStatusListRes,
			faultyValueListRes,
			moneyCdListRes,
			inoutBoundListRes,
			inoutClassListRes,
			inoutMethodListRes,
			interesttypeListRes,
			inspectTypeListRes,
			itemAccountListRes,
			itemGroupListRes,
			itemStatusListRes,
			jcCdListRes,
			jobTeamListRes,
			jjCdListRes,
			jwCdListRes,
			ordTypeListRes,
			paycollectListRes,
			paycollectTargetListRes,
			payTpListRes,
			retireTypeListRes,
			systemListRes,
			testClassListRes,
			unitListRes,
			valueTypeListRes,
			vatTypeListRes,
			vatIoFlagListRes,
			wmsCdListRes,
			wmsInTypeCdListRes,
			wmsOutTypeCdListRes,
			workProcessListRes,
			yesNoListRes,
			yesNoNumListRes,
			kpiKeyListRes, // 1. API 호출 결과를 받을 변수 추가
			plcaddressListRes,
			inoutTypeListRes,
		] = await Promise.all([
			getCommonCodeList(),
			getMinorCodeList('AREACD'),
			getMinorCodeList('AUTGROUP'),
			getMinorCodeList('CALENDARTYPE'),
			getMinorCodeList('BANKCD'),
			getMinorCodeList('BANKACCTTYPE'),
			getMinorCodeList('BRANDCD'),
			getMinorCodeList('COUNTRY'),
			getMinorCodeList('CARTYPE'),
			getMinorCodeList('CARMODEL'),
			getMinorCodeList('COMPJOINTP'),
			getMinorCodeList('CYCLE'),
			getMinorCodeList('DEVSTS'),
			getMinorCodeList('DEVLOPER'),
			getMinorCodeList('DOWNTIME_VALUE'),
			getMinorCodeList('EDUCATION'),
			getMinorCodeList('EMPSTS'),
			getMinorCodeList('EQMTYPE'),
			getMinorCodeList('EQMSTATUS'),
			getMinorCodeList('FAULTY_VALUE'),
			getMinorCodeList('MONEYCD'),
			getMinorCodeList('INOUTBOUND'),
			getMinorCodeList('INOUT_CLASS'),
			getMinorCodeList('INOUT_METHOD'),
			getMinorCodeList('INTERESTYPE'),
			getMinorCodeList('INSPECT_TYPE'),
			getMinorCodeList('ITEMACCOUNT'),
			getMinorCodeList('ITEMGROUP'),
			getMinorCodeList('ITEM_STATUS'),
			getMinorCodeList('JCCD'),
			getMinorCodeList('JOBTEAM'),
			getMinorCodeList('JJCD'),
			getMinorCodeList('JWCD'),
			getMinorCodeList('ORDTYPE'),
			getMinorCodeList('PAYCOLLECT'),
			getMinorCodeList('PAYCOLLECTCOMP'),
			getMinorCodeList('PAYTP'),
			getMinorCodeList('RETIRETYPE'),
			getMinorCodeList('SYSTEM'),
			getMinorCodeList('TEST'),
			getMinorCodeList('UNIT'),
			getMinorCodeList('VALUE_TYPE'),
			getMinorCodeList('VATTYPE'),
			getMinorCodeList('VAT_IO_FLAG'),
			getMinorCodeList('WMSCD'),
			getMinorCodeList('WMSINTYPE'),
			getMinorCodeList('WMSOUTTYPE'),
			getMinorCodeList('WORKPROCESS'),
			getMinorCodeList('YESNO'),
			getMinorCodeList('YESNO_NUM'),
			getMinorCodeList('KPIKEY'),
			getMinorCodeList('PLCADDRESS'),
			getMinorCodeList('INOUTTYPE'),
		]);
		set({
			majorCodeList:			majorCodeListRes.data.data,
			areaCdList:				areaCdListRes.data.data,
			autGroupList:			autGroupListRes.data.data,
			birthdayTypeList:		birthdayTypeListRes.data.data,
			bankCdList:				bankCdListRes.data.data,
			bankAcctTypeList:		bankAcctTypeListRes.data.data,
			brandCdList:			brandCdListRes.data.data,
			countryCdList:			countryCdListRes.data.data,
			carTypeList:			carTypeListRes.data.data,
			carModelList:			carModelListRes.data.data,
			compJoinTpList:			compJoinTpListRes.data.data,
			cycleList:				cycleListRes.data.data,
			devStsList:				devStsListRes.data.data,
			devloperList:			devloperListRes.data.data,
			downtimeValueList:		downtimeValueListRes.data.data,
			educationTypeList:		educationTypeListRes.data.data,
			empstsCdList:			empstsCdListRes.data.data,
			eqmTypeList:			eqmTypeListRes.data.data,
			eqmStatusList:			eqmStatusListRes.data.data,
			faultyValueList:		faultyValueListRes.data.data,
			moneyCdList:			moneyCdListRes.data.data,
			inoutBoundList:			inoutBoundListRes.data.data,
			inoutClassList:			inoutClassListRes.data.data,
			inoutMethodList:		inoutMethodListRes.data.data,
			interesttypeList:		interesttypeListRes.data.data,
			inspectTypeList:		inspectTypeListRes.data.data,
			itemAccountList:		itemAccountListRes.data.data,
			itemGroupList:			itemGroupListRes.data.data,
			itemStatusList:			itemStatusListRes.data.data,
			jcCdList:				jcCdListRes.data.data,
			jobTeamList:			jobTeamListRes.data.data,
			jjCdList:				jjCdListRes.data.data,
			jwCdList:				jwCdListRes.data.data,
			ordTypeList:			ordTypeListRes.data.data,
			paycollectList:			paycollectListRes.data.data,
			paycollectTargetList:	paycollectTargetListRes.data.data,
			payTpList:				payTpListRes.data.data,
			retireTypeList:			retireTypeListRes.data.data,
			systemList:				systemListRes.data.data,
			testClassList:			testClassListRes.data.data,
			unitList:				unitListRes.data.data,
			valueTypeList:			valueTypeListRes.data.data,
			vatTypeList:			vatTypeListRes.data.data,
			vatIoFlagList:			vatIoFlagListRes.data.data,
			wmsCdList:				wmsCdListRes.data.data,
			wmsInTypeCdList:		wmsInTypeCdListRes.data.data,
			wmsOutTypeCdList:		wmsOutTypeCdListRes.data.data,
			workProcessList:		workProcessListRes.data.data,
			yesNoList:				yesNoListRes.data.data,
			yesNoNumList:			yesNoNumListRes.data.data,
			kpiKeyList:				kpiKeyListRes.data.data, // 2. 받아온 결과를 스토어 상태에 저장
			plcaddressList:			plcaddressListRes.data.data,
			inoutTypeList:			inoutTypeListRes.data.data,
		});
	},

	fetchBankacctCdCode: async () => {
		const [ bankacctCdListRes, ] = await Promise.all([ getBankacctList(''), ]);
		set({ bankacctCdList: bankacctCdListRes.data.data, });
	},
	fetchBookmarkCdCode: async () => {
		// const [ bookmarkCdListRes, ] = await Promise.all([ getBookmarkList(), ]);
		// const data = bookmarkCdListRes.data.data;

		// if (Array.isArray(data)) {
		// 	set({ bookmarkCdList: data });
		// } else {
		// 	set({ bookmarkCdList: [] });
		// }
	},
	fetchCustomCdCode: async () => {
		const [ customCdListRes, ] = await Promise.all([ getCustomerList('all'), ]);
		set({ customCdList: customCdListRes.data.data, });
	},

	fetchCompCdCode: async () => {
		const [ compCdListRes, ] = await Promise.all([ getCompCdList(), ]);
		set({ compCdList: compCdListRes, });
	},
	fetchEmployeeCdCode: async () => {
		const [ employeeCdListRes, ] = await Promise.all([ getEmployeeList(), ]);
		set({ employeeCdList: employeeCdListRes.data.data, });
	},
	fetchMenuCdCode: async () => {
		const [ menuCdListRes, ] = await Promise.all([ getMenuModalList(), ]);
		set({ menuCdList: menuCdListRes.data.data, });
	},
	fetchOrgCdCode: async () => {
		const [ orgCdListRes, ] = await Promise.all([ getOrgCdList(), ]);
		set({ orgCdList: orgCdListRes, });
	},
	fetchWarehouseCdCode: async () => {
		const [ warehouseCdListRes, ] = await Promise.all([ getAllWarehouses(), ]);
		set({ warehouseCdList: warehouseCdListRes.data.data, });
	},
	fetchWorkPlaceCdCode: async () => {
		const [ workPlaceListRes, ] = await Promise.all([ getAllWorkPlaces(), ]);
		set({ workPlaceList: workPlaceListRes.data.data, });
	},

	plcaddressList: [],
	setPlcaddressList: (data: CodeResponseDto[]) => set((state) => { return { ...state, plcaddressList: data } }),
 
	bookMarkCd: '$$$',
	
	//초기화
	initData: () => set((state) => ({
		...state,
		codeInput: '',
		minorCodeList: [],
		selectedMinorCodeList: [],
		deletedMinorCodeList: [],
		filteredMajorCodeList: [],
		selectedMajorCode: undefined,
	})),

	areaCdList: [],
	setAreaCdList: (data: CodeResponseDto[]) => set((state) => { return { ...state, areaCdList: data
		}
	}),

	autGroupList: [],
	setAutGroupList: (data: CodeResponseDto[]) => set((state) => { return { ...state, autGroupList: data } }),

	birthdayTypeList: [],
	setBirthdayTypeList: (data: CodeResponseDto[]) => set((state) => { return { ...state, birthdayTypeList: data } }),

	bankCdList: [],
	setBankCdList: (data: CodeResponseDto[]) => set((state) => { return { ...state, bankCdList: data } }),

	bankAcctTypeList: [],
	setBankAcctTypeList: (data: CodeResponseDto[]) => set((state) => { return { ...state, bankAcctTypeList: data } }),

	brandCdList: [],
	setBrandCdList: (data: CodeResponseDto[]) => set((state) => { return { ...state, brandCdList: data } }),

	countryCdList: [],
	setCountryCdList: (data: CodeResponseDto[]) => set((state) => { return { ...state, countryCdList: data } }),

	carTypeList: [],
	setCarTypeList: (data: CodeResponseDto[]) => set((state) => { return { ...state, carTypeList: data } }),

	carModelList: [],
	setCarModelList: (data: CodeResponseDto[]) => set((state) => { return { ...state, carModelList: data } }),

	compJoinTpList: [],
	setCompJoinTpList: (data: CodeResponseDto[]) => set((state) => { return { ...state, compJoinTpList: data } }),

	cycleList: [],
	setCycleList: (data: CodeResponseDto[]) => set((state) => { return { ...state, cycleList: data } }),

	devStsList: [],
	setDevStsList: (data: CodeResponseDto[]) => set((state) => { return { ...state, devStsList: data } }),

	devloperList: [],
	setDevloperList: (data: CodeResponseDto[]) => set((state) => { return { ...state, devloperList: data } }),

	downtimeValueList: [],
	setDowntimeValueList: (data: CodeResponseDto[]) => set((state) => { return { ...state, downtimeValueList: data } }),

	educationTypeList: [],
	setEducationTypeList: (data: CodeResponseDto[]) => set((state) => { return { ...state, educationTypeList: data } }),

	empstsCdList: [],
	setEmpstsCdList: (data: CodeResponseDto[]) => set((state) => { return { ...state, empstsCdList: data } }),

	eqmTypeList: [],
	setEqmTypeList: (data: CodeResponseDto[]) => set((state) => { return { ...state, eqmTypeList: data } }),

	eqmStatusList: [],
	setEqmStatusList: (data: CodeResponseDto[]) => set((state) => { return { ...state, eqmStatusList: data } }),

	faultyValueList: [],
	setFaultyValueList: (data: CodeResponseDto[]) => set((state) => { return { ...state, faultyValueList: data } }),

	moneyCdList: [],
	setMoneyCdList: (data: CodeResponseDto[]) => set((state) => { return { ...state, moneyCdList: data } }),

	inoutBoundList: [],
	setInoutBoundList: (data: CodeResponseDto[]) => set((state) => { return { ...state, inoutBoundList: data } }),

	inoutClassList: [],
	setInoutClassList: (data: CodeResponseDto[]) => set((state) => { return { ...state, inoutClassList: data } }),

	inoutMethodList: [],
	setInoutMethodList: (data: CodeResponseDto[]) => set((state) => { return { ...state, inoutMethodList: data } }),

	interesttypeList: [],
	setInteresttypeList: (data: CodeResponseDto[]) => set((state) => { return { ...state, interesttypeList: data } }),

	inspectTypeList: [],
	setInspectTypeList: (data: CodeResponseDto[]) => set((state) => { return { ...state, inspectTypeList: data } }),

	itemAccountList: [],
	setItemAccountList: (data: CodeResponseDto[]) => set((state) => { return { ...state, itemAccountList: data } }),

	itemGroupList: [],
	setItemGroupList: (data: CodeResponseDto[]) => set((state) => { return { ...state, itemGroupList: data } }),

	itemStatusList: [],
	setItemStatusList: (data: CodeResponseDto[]) => set((state) => { return { ...state, itemStatusList: data } }),

	jcCdList: [],
	setJcCdList: (data: CodeResponseDto[]) => set((state) => { return { ...state, jcCdList: data } }),

	jobTeamList: [],
	setJobTeamList: (data: CodeResponseDto[]) => set((state) => { return { ...state, jobTeamList: data } }),

	jjCdList: [],
	setJjCdList: (data: CodeResponseDto[]) => set((state) => { return { ...state, jjCdList: data } }),

	jwCdList: [],
	setJwCdList: (data: CodeResponseDto[]) => set((state) => { return { ...state, jwCdList: data } }),

	// 3. KPI 구분 상태와 setter를 스토어에 추가
	kpiKeyList: [],
	setKpiKeyList: (data: CodeResponseDto[]) => set((state) => { return { ...state, kpiKeyList: data } }),

	ordTypeList: [],
	setOrdTypeList: (data: CodeResponseDto[]) => set((state) => { return { ...state, ordTypeList: data } }),

	paycollectList: [],
	setPaycollectList: (data: CodeResponseDto[]) => set((state) => { return { ...state, paycollectList: data } }),

	paycollectTargetList: [],
	setPaycollectTargetList: (data: CodeResponseDto[]) => set((state) => {

		// console.log('setPaycollectTargetList data :', data);

		return {
			...state,
			paycollectTargetList: data 
		} 
	}),

	payTpList: [],
	setPayTpList: (data: CodeResponseDto[]) => set((state) => { return { ...state, payTpList: data } }),

	retireTypeList: [],
	setRetireTypeList: (data: CodeResponseDto[]) => set((state) => { return { ...state, retireTypeList: data } }),

	systemList: [],
	setSystemList: (data: CodeResponseDto[]) => set((state) => { return { ...state, systemList: data } }),

	testClassList: [],
	setTestClassList: (data: CodeResponseDto[]) => set((state) => { return { ...state, testClassList: data } }),

	unitList: [],
	setUnitList: (data: CodeResponseDto[]) => set((state) => { return { ...state, unitList: data } }),

	valueTypeList: [],
	setValueTypeList: (data: CodeResponseDto[]) => set((state) => { return { ...state, valueTypeList: data } }),

	vatTypeList: [],
	setVatTypeList: (data: CodeResponseDto[]) => set((state) => { return { ...state, vatTypeList: data } }),

	vatIoFlagList: [],
	setVatIoFlagList: (data: CodeResponseDto[]) => set((state) => { return { ...state, vatIoFlagList: data } }),

	workProcessList: [],
	setWorkProcessList: (data: CodeResponseDto[]) => set((state) => { return { ...state, workProcessList: data } }),

	wmsCdList: [],
	setWmsCdList: (data: CodeResponseDto[]) => set((state) => { return { ...state, wmsCdList: data } }),

	wmsInTypeCdList: [],
	setWmsInTypeCdList: (data: CodeResponseDto[]) => set((state) => { return { ...state, wmsInTypeCdList: data } }),

	wmsOutTypeCdList: [],
	setWmsOutTypeCdList: (data: CodeResponseDto[]) => set((state) => { return { ...state, wmsOutTypeCdList: data } }),

	// 입고분류 (PUR2020_R01 검색조건)
	inoutTypeList: [],
	setInoutTypeList: (data: CodeResponseDto[]) => set((state) => { return { ...state, inoutTypeList: data } }),

	yesNoList: [],
	setYesNoList: (data: CodeResponseDto[]) => set((state) => { return { ...state, yesNoList: data } }),

	yesNoNumList: [],
	setYesNoNumList: (data: CodeResponseDto[]) => set((state) => { return { ...state, yesNoNumList: data } }),

	bankacctCdList: [],
	setBankacctCdList: (data: BankAcctDto[]) => set((state) => { return { ...state, bankacctCdList: data } }),

	bookmarkCdList: [],
	setBookmarkCdList: (data: BookmarkCdList[]) => set((state) => { return { ...state, bookmarkCdList: data } }),

	customCdList: [],
	setCustomCdList: (data: CustomerResponseDto[]) => set((state) => { return { ...state, customCdList: data } }),

	compCdList: [],
	setCompCdList: (data: CompanyDto[]) => set((state) => { return { ...state, compCdList: data } }),

	employeeCdList: [],
	setEmployeeCdList: (data: EmployeeDto[]) => set((state) => { return { ...state, employeeCdList: data } }),

	menuCdList: [],
	setMenuCdList: (data: MenuDto[]) => set((state) => { return { ...state, menuCdList: data } }),

	orgCdList: [],
	setOrgCdList: (data: OrganizationDto[]) => set((state) => { return { ...state, orgCdList: data }}),

	warehouseCdList: [],
	setWarehouseCdList: (data: WareHouseDto[]) => set((state) => { return { ...state, warehouseCdList: data } }),

	workPlaceList: [],
	setWorkPlaceList: (data: WorkPlaceDto[]) => set((state) => { return { ...state, workPlaceList: data } }),

	// 검색 조건 초기값
	searchCondition: {
		majorCd: '',
		minorCd: '',
		codeNm: ''
	},
	setSearchCondition: (condition) => set((state) => ({
		...state,
		searchCondition: {
			...state.searchCondition,
			...condition
		}
	})),
	resetSearchCondition: () => set((state) => ({
		...state,
		searchCondition: {
			majorCd: '',
			minorCd: '',
			codeNm: ''
		}
	})),

	// 상세코드 옵션 관련
	minorCodeOptions: [],
	setMinorCodeOptions: (options) => set((state) => ({
		...state,
		minorCodeOptions: options
	})),
	fetchMinorCodeOptions: async (majorCd) => {
		try {
			const response = await getMinorCodeList(majorCd);
			if (response?.data?.data) {
				set((state) => ({
					...state,
					minorCodeOptions: response.data.data
				}));
			}
		} catch (error) {
			console.error('상세코드 조회 실패:', error);
			set((state) => ({
				...state,
				minorCodeOptions: []
			}));
		}
	},

	// 검색조건용 상세코드 관련
	conditionCodeOptions: [],
	setConditionCodeOptions: (options) => set((state) => ({
		...state,
		conditionCodeOptions: options
	})),
	fetchConditionCodeOptions: async (majorCd) => {
		try {
			const response = await getConditionCodeList(majorCd);
			if (response?.data?.data) {
				set((state) => ({
					...state,
					conditionCodeOptions: response.data.data
				}));
			}
		} catch (error) {
			console.error('검색조건용 상세코드 조회 실패:', error);
			set((state) => ({
				...state,
				conditionCodeOptions: []
			}));
		}
	},

	// 메이저코드 드롭다운 옵션 관련
	majorCodeOptions: [],
	setMajorCodeOptions: (options) => set((state) => ({
		...state,
		majorCodeOptions: options
	})),
	fetchMajorCodeOptions: async () => {
		try {
			const response = await getMajorCodeOptions();
			if (response?.data?.data) {
				set((state) => ({
					...state,
					majorCodeOptions: response.data.data
				}));
			}
		} catch (error) {
			console.error('메이저코드 옵션 조회 실패:', error);
			set((state) => ({
				...state,
				majorCodeOptions: []
			}));
		}
	},
}));